module.exports = __webpack_public_path__ + "90c0d566.svg";